// libs
import React, { memo, useEffect, useRef } from 'react';

// styles
import { Container, Action } from './styles';
import { TAB_INDEX } from 'shared/constants';

// defs
export interface ToastProps {
  message: string;
  actionText?: string;
  onActionClick?: VoidFunction;
  onToastHide?: VoidFunction;
  animationTimeMilliSeconds?: number;
  className?: string;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

function Toast({
  message,
  actionText,
  onActionClick = EMPTY_FUNC,
  onToastHide = EMPTY_FUNC,
  animationTimeMilliSeconds = 5000,
  className = '',
}: ToastProps) {
  const animationTime = animationTimeMilliSeconds / 1000;
  const toastRef = useRef<HTMLDivElement>(null);

  // Focus the toast when it appears so VoiceOver reads it
  useEffect(() => {
    if (toastRef.current) {
      const timer = setTimeout(() => {
        toastRef.current?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <Container
      ref={toastRef}
      className={className}
      onAnimationEnd={onToastHide}
      animationTime={animationTime}
      data-test="toast-container"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      tabIndex={TAB_INDEX.ACTION_VISIBILITY}
    >
      {message}
      {actionText !== undefined && (
        <Action onClick={onActionClick} data-test="toast-action">
          {actionText}
        </Action>
      )}
    </Container>
  );
}

export default memo(Toast);
